/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Map_Vehicle_LocateInputs */

const fr_map_vehicle_locate = /** @type {(inputs: Map_Vehicle_LocateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Localiser sur la carte`)
};

const en_map_vehicle_locate = /** @type {(inputs: Map_Vehicle_LocateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Locate on the map`)
};

/**
* | output |
* | --- |
* | "Locate on the map" |
*
* @param {Map_Vehicle_LocateInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const map_vehicle_locate = /** @type {((inputs?: Map_Vehicle_LocateInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Map_Vehicle_LocateInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_map_vehicle_locate(inputs)
	return en_map_vehicle_locate(inputs)
});